export default __webpack_public_path__ + "static/digital-ocean-da11b7b0539ce1d95b0f73ea900dbbcc.svg";